import React from 'react';
import PropTypes from 'prop-types';
import styles from './LeadsHealthMeter.module.scss';

const LeadsHealthMeter = ({ healthCheckVal, projectId }) => {
  return (
    <>
      <div className="p-20">
        <div className="font16 fw700 color111 pb-20">
          {projectId === 'csportal' ? 'Your leads health check report!' : "Client's leads health check report!"}
        </div>
        <div className={`${styles.LeadsHealthMeterBox} `}>
          <div className={`${styles.LeadsHealthMeter__imagebox} pt-20 pl-20 pb-10 pr-20`}>
            <div className="font11 fw500 color111 pb-10">Average</div>
            <img
              alt="healthmeter"
              className={`${styles.LeadsHealthMeter__image}`}
              src="https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/healthmeter_background.svg"
            />
            <div className={`${styles.LeadsHealthMeter__rotate} csicon`}>
              <div className={`${styles.LeadsHealthMeter__rotatedot} csicon`} />
              <div
                style={{ transform: `rotate(${healthCheckVal?.val || 0}deg)` }}
                className={`${styles.LeadsHealthMeter__rotatearrow} csicon`}
              />
            </div>
            <div className={`${styles.LeadsHealthMeter__textbox} font11 fw500 color111 pt-10 pb-10`}>
              <div className={`${styles.LeadsHealthMeter__text} font11 fw500 color111`}>Poor</div>
              <div className={`${styles.LeadsHealthMeter__text} font11 fw500 color111`}>Excellent</div>
            </div>
          </div>
          <div className={`${styles.LeadsHealthMeter__pannel} font13 fw600 color111`}>{healthCheckVal?.text || ''}</div>
        </div>
      </div>
    </>
  );
};

export default LeadsHealthMeter;

LeadsHealthMeter.propTypes = {
  healthCheckVal: PropTypes.any,
  projectId: PropTypes.string,
};

LeadsHealthMeter.defaultProps = {
  healthCheckVal: {},
  projectId: '',
};
